import {
    ADD_SLIDE_TO_SPLIT_SYNC_VIEW,
    CLEAR_ALL_SLIDES_FROM_SPLIT_SYNC_VIEW,
    REPLACE_SLIDES_IN_SPLIT_SYNC_VIEW
} from "../redux_constants/splitSyncSlides.constant";
import {isNull} from "../utils/utils";


const InitialState = {
    slides: []
}

export const splitSyncSlideReducer = (state = InitialState, action) => {
    switch (action.type) {
        case ADD_SLIDE_TO_SPLIT_SYNC_VIEW:
            const slideToAdd = action.slide;
            if (isNull(slideToAdd.id)) {
                return state;
            }
            const isSlideAlreadyPresent = state.slides.some(slide => slide.id === slideToAdd.id);
            if (!isSlideAlreadyPresent) {
                return {
                    slides: [...state.slides, slideToAdd]
                };
            }
            return state;
        case REPLACE_SLIDES_IN_SPLIT_SYNC_VIEW:
            const slides = [];
            action.slides.forEach(slide => {
                slides.push({
                    id: slide.id,
                    name: slide.name
                })
            })

            return {slides}
        case CLEAR_ALL_SLIDES_FROM_SPLIT_SYNC_VIEW:
            return InitialState
        default:
            return state
    }
}